import React, { useEffect, useCallback, useState} from 'react';
import Structure from "components/effects/tidal/Structure.js";
import {connect} from 'react-redux';
import {getCycleString} from "effects/midi/tidal/parser.js"

const TrackTidal = ({track, effect}) => { 
    let tidal = effect.tidals[track-1];
    if (tidal) {
        return (
            <div>
              <Structure
                WIDTH={110}
                HEIGHT={110}
                tidals={[tidal]}
                color="#F6F6E9"
                backgroundColor="#2D2D2E"
                fillColor="#747474"
                dotColor="#E8ECFF"
              />
            </div>);
    }
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackTidal);
